import { LIFESTYLE_IMAGE } from "../../data/promill";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";

const POINTS = [
    "Designed for desk warriors, gym rats & weekend athletes",
    "Ready in under 6 minutes — order on the app, eat at the desk",
    "Sourced from millet farmers across Karnataka, Andhra & Rajasthan",
    "Compostable packaging. Real impact. Zero greenwash.",
];

export const Lifestyle = () => (
    <section
        id="franchise"
        data-testid="lifestyle-section"
        className="bg-pm-cream py-20 md:py-28"
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
                <div className="relative">
                    <div aria-hidden className="absolute -inset-4 bg-pm-yellow rounded-[28px] -rotate-3" />
                    <img
                        src={LIFESTYLE_IMAGE}
                        alt="Modern Indian lifestyle"
                        data-testid="lifestyle-image"
                        className="relative w-full aspect-[4/5] object-cover rounded-2xl border-[3px] border-pm-black shadow-[10px_10px_0_0_#075B2B]"
                    />
                    <div className="absolute -bottom-6 right-4 z-10 bg-pm-black text-pm-yellow font-display text-2xl uppercase tracking-wider px-5 py-3 rounded-xl rotate-3 border-2 border-pm-yellow">
                        Good Food. Real Impact.
                    </div>
                </div>

                <div>
                    <span className="inline-block text-pm-orange font-bold tracking-[0.3em] uppercase text-xs mb-3">
                        Made for India
                    </span>
                    <h2 className="font-display text-5xl md:text-6xl uppercase leading-[0.95] text-pm-green">
                        Made for everyday<br />
                        <span className="text-pm-orange">modern eating.</span>
                    </h2>
                    <p className="mt-5 text-lg text-pm-black/80 leading-relaxed">
                        From the boardroom in BKC to the gym floor in Indiranagar — ProMill brings
                        the power of Indian millets to wherever your hustle takes you. Built for
                        bodies in motion, taste buds with standards, and a planet that deserves better.
                    </p>

                    <ul className="mt-7 space-y-3">
                        {POINTS.map((pt, i) => (
                            <li key={i} data-testid={`lifestyle-point-${i}`} className="flex gap-3 items-start">
                                <span className="flex-shrink-0 h-7 w-7 rounded-full bg-pm-green text-pm-yellow flex items-center justify-center border-2 border-pm-black">
                                    <Check className="w-4 h-4" />
                                </span>
                                <span className="text-base font-medium pt-0.5">{pt}</span>
                            </li>
                        ))}
                    </ul>

                    <Link to="/menu" data-testid="lifestyle-cta" className="btn-brutal btn-brutal--primary mt-8 inline-flex">
                        Explore Menu →
                    </Link>
                </div>
            </div>
        </div>
    </section>
);
